import {combineReducers} from 'redux';
import storestate from './storestate';
import getFirebaseUsersReducer from './getFirebaseUsersReducer';

export default combineReducers({
    store : storestate,
    FireBaseUsers : getFirebaseUsersReducer
});